<template>
  <multiselect
    v-model="selectedCrms"
    id="ajax"
    placeholder=""
    open-direction="bottom"
    :options="crmList"
    :multiple="true"
    :searchable="true"
    :disabled="this.$props.disabled"
    :loading="isLoading"
    :internal-search="false"
    :clear-on-select="false"
    :close-on-select="true"
    @select="handleSelect"
    :options-limit="15"
    :limit="3"
    :limit-text="limitText"
    :deselect-label="'Remover item'"
    :selected-label="'Selecionado'"
    :select-label="'Selecionar'"
    :max-height="600"
    :show-no-results="true"
    @search-change="asyncFindCrms"
  >
    <template #tag="{ option, remove }"
      ><span class="custom__tag"
        ><span>{{ option }}</span
        ><span
          class="custom__remove"
          @click="
            () => {
              removeElement(option);
              remove(option);
            }
          "
        >
          <img
            class="custom-icon-remove"
            src="@/assets/icons/close-circle.svg" /></span></span
    ></template>
    <template #noOptions>
      <span class="custom-no-options"
        >Comece a escrever para inciar consulta.</span
      >
    </template>
    <template #clear="props">
      <div
        class="multiselect__clear"
        v-if="selectedCrms.length"
        @mousedown.prevent.stop="clearAll(props.search)"
      ></div>
    </template>
    <span slot="noResult"
      >Nenhum crm encontrado, tente refazer a consulta.</span
    >
  </multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";
import getCrms from "../../services/crms/crms";
import { createToast } from "../toast/toast";

export default {
  components: { Multiselect },
  props: ["crms", "toRemove", "toOnly", "disabled"],
  async mounted() {
    this.selectedCrms.concat(this.$props.crms);
    if (!this.$props.disabled) this.getAllCrmsToCache();
  },
  data() {
    return {
      selectedCrms: [],
      crmList: [],
      crmListAll: [],
      isLoading: false,
    };
  },
  watch: {
    crms: {
      immediate: true,
      handler(newValue) {
        if (this.isArrayEmpty(newValue)) {
          this.selectedCrms = [...new Set([...this.selectedCrms])];
        } else {
          this.selectedCrms = [...new Set([...this.selectedCrms, ...newValue])];
        }
      },
    },
  },
  methods: {
    removeElement(elementToRemove) {
      const newList = this.selectedCrms.filter(
        (item) => item !== elementToRemove
      );
      if (newList.length !== this.selectedCrms.length) {
        this.selectedCrms = newList;
        this.$emit("onSelectCrm", this.selectedCrms);
      }
    },
    handleSelect() {
      this.crmList = [];
      this.$emit("onSelectCrm", this.selectedCrms);
    },
    limitText(count) {
      return `e ${count} outros crms`;
    },
    getAllCrmsToCache() {
      this.isLoading = true;
      getCrms()
        .then((response) => {
          this.crmListAll = response;
          this.isLoading = false;
        })
        .catch((err) => {
          createToast("Erro", "Não foi possível consultar os crms.");
          console.error("getAllCrmsToCache", err);
          this.isLoading = false;
        });
    },
    isArrayEmpty(arr) {
      return !arr?.length;
    },
    asyncFindCrms(query) {
      let filteredList = this.crmListAll.filter((item) =>
        item.startsWith(query)
      );

      if (!this.isArrayEmpty(this.$props.toOnly)) {
        filteredList = filteredList.filter((item) =>
          this.$props.toOnly.includes(item)
        );
      } else if (!this.isArrayEmpty(this.$props.toRemove)) {
        filteredList = filteredList.filter(
          (item) =>
            !this.selectedCrms.includes(item) &&
            !this.$props.toRemove.includes(item)
        );
      } else {
        filteredList = filteredList.filter(
          (item) => !this.selectedCrms.includes(item)
        );
      }

      this.crmList = filteredList;
    },
    clearAll() {
      this.selectedCrms = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-icon-remove {
  margin-bottom: 2.8px;
  margin-left: 1.5px;
  margin-right: 2px;
}
</style>
